import vue from 'vue'
//import router from 'vue-router'
import store from '@@/assets/js/store';
import {
  sync
} from 'vuex-router-sync'
import home from '@@/pages/contract/home'

import westaHome from '@@/pages/westa/home'
import westaAbout from '@@/pages/westa/about'
import westaProduct from '@@/pages/westa/product'
import westaBaking from '@@/pages/westa/baking'
import westaShopping from '@@/pages/westa/shopping'
import westaActivtiy from '@@/pages/westa/activity'
import westaJoin from '@@/pages/westa/join'
import westaService from '@@/pages/westa/service'
import westaContact from '@@/pages/westa/contact'
import westaSearch from '@@/pages/westa/search'
import westaDetail from '@@/pages/westa/product_detail'
import {
  CLIENT_RENEG_WINDOW
} from 'tls';


const router_c = new VueRouter({
  base: "/",
  mode: 'history',
  routes: [{
    path: '/contract',
    component: home,
    meta: {
      name: "主界面",

    },
    children: [{
      path: '/contract',
      component: home,
      meta: {
        name: "主界面",
      }
    },]
  },
  {
    path: '/',
    // component: westaHome,
    component: function (resolve) {
      require(['@@/pages/westa/home'], resolve)
    },
    meta: {
      name: "首页"
    }
  },
  {
    path: '/home',
    // component: westaHome,
    component: function (resolve) {
      require(['@@/pages/westa/home'], resolve)
    },
    meta: {
      name: "首页"
    }
  },
  {
    path: '/about',
    // component: westaAbout,
    component: function (resolve) {
      require(['@@/pages/westa/about'], resolve)
    },
    meta: {
      name: "关于长帝"
    }
  },
  {
    path: '/product',
    // component: westaProduct,
    component: function (resolve) {
      require(['@@/pages/westa/product'], resolve)
    },
    meta: {
      name: "产品中心"
    }
  },
  {
    path: '/detail',
    // component: westaDetail,
    component: function (resolve) {
      require(['@@/pages/westa/product_detail'], resolve)
    },
    meta: {
      name: "产品详情"
    }
  },
  // {
  //   path: '/lebeiapp',
  //   component: westaLebeiapp,
  //   meta: {
  //     name: "乐焙APP"
  //   }
  // },
  {
    path: '/baking',
    // component: westaBaking,
    component: function (resolve) {
      require(['@@/pages/westa/baking'], resolve)
    },
    meta: {
      name: "分类美食"
    }
  },
  {
    path: '/shopping',
    // component: westaShopping,
    component: function (resolve) {
      require(['@@/pages/westa/shopping'], resolve)
    },
    meta: {
      name: "在线购买"
    }
  },
  {
    path: '/activity',
    // component: westaActivtiy,
    component: function (resolve) {
      require(['@@/pages/westa/activity'], resolve)
    },
    meta: {
      name: "品牌活动"
    }
  },
  {
    path: '/join',
    // component: westaJoin,
    component: function (resolve) {
      require(['@@/pages/westa/join'], resolve)
    },
    meta: {
      name: "加入我们"
    }
  },
  {
    path: '/service',
    // component: westaService,
    component: function (resolve) {
      require(['@@/pages/westa/service'], resolve)
    },
    meta: {
      name: "在线服务"
    }
  },
  {
    path: '/contact',
    // component: westaContact,
    component: function (resolve) {
      require(['@@/pages/westa/contact'], resolve)
    },
    meta: {
      name: "联系我们"
    }
  },
  {
    path: '/search',
    // component: westaSearch,
    component: function (resolve) {
      require(['@@/pages/westa/search'], resolve)
    },
    meta: {
      name: "搜索"
    }
  },
  ],
})
sync(store, router_c)
router_c.beforeEach((to, from, next) => {
  // next()
  if (to.path.indexOf("http") > -1) {
    let url = to.fullPath.replace('/', '')
    window.open(url)
  } else {
    next()
  }


});
router_c.afterEach(function (to, from) {
  store.commit('TO_ROUTER_TABS', [to, from])
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

})
export default router_c;
